<template>

  <div class="formulario">
    <b-card no-body>
      <b-card-group deck>
        <b-card header-tag="header" bg-variant="light">
          <template v-slot:header>
            <i class="fas fa-exchange-alt"></i>
            <span class="ml-1">Transferencias SIPAP (a Bancos)</span>
          </template>
          
          <b-row>
            <b-col>
              <b-form-group id="IG_cuenta_origen" label="Cuenta origen o de débito:" label-for="IF_cuenta_origen">
                <b-form-select ref="select_co" v-model="item.cuenta_origen" :options="cuentas_origen" required />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="IG_entidad" label="Banco destino:" label-for="IF_entidad">
                <b-form-select ref="select_bd" v-model="item.entidad" :options="entidades" required />
              </b-form-group>
            </b-col>       
          </b-row>

          <b-row>
            <b-col>
              <b-form-group id="IG_numero_cuenta_destino" label="Nº Cuenta destino:" label-for="IF_numero_cuenta_destino" >
                <b-form-input ref="numero_cuenta_destino" id="IF_numero_cuenta_destino" type="text" v-model="item.numero_cuenta_destino" placeholder="Nº Cuenta destinatario" autocomplete="off"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="IG_tipo_documento" label="Tipo Documento destinatario:" label-for="IF_tipo_documento">
                <b-form-select ref="select_td" v-model="item.tipo_documento" :options="tiposdocumento" required />
              </b-form-group>
            </b-col>       
          </b-row>

          <b-row>
            <b-col>
              <b-form-group id="IG_numero_documento" label="Nº Documento destinatario:" label-for="IF_numero_documento" >
                <b-form-input ref="numero_documento" id="IF_numero_documento" type="text" v-model="item.numero_documento" placeholder="Nº de documento destinatario" autocomplete="off"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="IG_nombre_destinatario" label="Nombre y Apellido destinatario:" label-for="IF_nombre_destinatario" >
                <b-form-input ref="nombre_destinatario" id="IF_nombre_destinatario" type="text" v-model="item.nombre_destinatario" placeholder="Nombre y Apellido destinatario" autocomplete="off"></b-form-input>
              </b-form-group>
            </b-col>       
          </b-row>

          <b-row>
            <b-col>
              <b-form-group id="IG_localidad" label="Localidad:" label-for="IF_localidad">
                <b-form-select ref="select_ld" v-model="item.localidad" :options="localidades" required />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="IG_importe" label="Monto a transferir:" label-for="IF_importe" >
                <b-form-input ref="importe" id="IF_importe" type="number" v-model="item.importe" placeholder="Importe a transferir" autocomplete="off"></b-form-input>
              </b-form-group>
            </b-col>       
          </b-row>

          <b-row>
            <b-col>
              <b-form-group id="IG_motivo" label="Motivo de la transferencia:" label-for="IF_motivo">
                <b-form-select ref="select_mv" v-model="item.motivo" :options="motivos" required />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="IG_concepto" label="Concepto:" label-for="IF_concepto" >
                <b-form-input ref="concepto" id="IF_concepto" type="text" v-model="item.concepto" placeholder="Concepto de la transferencia" autocomplete="off"></b-form-input>
              </b-form-group>
            </b-col>       
          </b-row>

          <b-row>
            <b-col>
              <b-btn class="btn-block" size="sm" variant="success" @click="botonTransferir">
                <i class="fas fa-exchange-alt"></i>  
                <span class="ml-2">Transferir</span> 
              </b-btn>
            </b-col>
          </b-row>

        </b-card>
        
      </b-card-group>
    </b-card>

    <b-modal
      id="modal-pin-transaccional"
      ref="modal-pin-transaccional"
      title="PIN Transaccional"
      @show="resetModalPinTransaccional"
      @hidden="resetModalPinTransaccional"
      @ok="handleOkPinTransaccional"
      cancel-title="Cancelar"
      ok-title="Transferir"
    >
      <form ref="formPinTransaccional" @submit.stop.prevent="handleSubmitPinTransaccional">
        <b-form-group
          :state="nameState"
          label="Ingrese su PIN Transaccional"
          label-for="pin-transaccional"
          label-class="label-pin"
          invalid-feedback="Pin transaccional requerido."
        >
          <b-form-input
            class="input_clave"
            readonly
            id="pinTransaccional"
            ref="pinTransaccional"
            v-model="pin_transaccional"
            :state="nameState"
            type="password"
            minlength=6
            maxlength=6
            required
            autofocus
          ></b-form-input>
        </b-form-group>
        <b-row class="fila_numeros">
          <b-col><div class="boton_teclado" @click="oprimeTecla($event)">1</div></b-col>
          <b-col><div class="boton_teclado" @click="oprimeTecla($event)">2</div></b-col>
          <b-col><div class="boton_teclado" @click="oprimeTecla($event)">3</div></b-col>
        </b-row>
        <b-row class="fila_numeros">
          <b-col><div class="boton_teclado" @click="oprimeTecla($event)">4</div></b-col>
          <b-col><div class="boton_teclado" @click="oprimeTecla($event)">5</div></b-col>
          <b-col><div class="boton_teclado" @click="oprimeTecla($event)">6</div></b-col>
        </b-row>
        <b-row class="fila_numeros">
          <b-col><div class="boton_teclado" @click="oprimeTecla($event)">7</div></b-col>
          <b-col><div class="boton_teclado" @click="oprimeTecla($event)">8</div></b-col>
          <b-col><div class="boton_teclado" @click="oprimeTecla($event)">9</div></b-col>
        </b-row>
        <b-row class="fila_numeros">
          <b-col><div class="boton_teclado" @click="limpiarPIN" style="color:#890909;">
            <i class="fas fa-trash"> </i>
            </div></b-col>
          <b-col><div class="boton_teclado" @click="oprimeTecla($event)">0</div></b-col>
          <b-col><div class="boton_teclado" @click="borrarCaracter" style="color:#890909;">
            <i class="fas fa-angle-left"> </i> 
            </div></b-col>
        </b-row>
      </form>
    </b-modal>

    <!--
      Aca va el modal para dar de alta una cuenta ...
    -->
    <b-modal
      id="modal-alta-cuenta-asociada"
      ref="modal-alta-cuenta-asociada"
      title="Nueva Cuenta Asociada"
      @show="resetModalAltaCuentaAsociada"
      @hidden="resetModalAltaCuentaAsociada"
      @ok="handleOkAltaCuentaAsociada"
      cancel-title="Cancelar"
      ok-title="Guardar"
    >
      <form ref="formAltaCuentaAsociada" @submit.stop.prevent="handleSubmitAltaCuentaAsociada">

        <b-form-group
          :state="nameState"
          label="Nombre del socio"
          label-for="nombreClienteAsociado"
          invalid-feedback="Nombre del socio requerido."
        >
          <b-form-input
            id="nombreClienteAsociado"
            ref="nombreClienteAsociado"
            v-model="new_cuenta_asociada.nombre_cliente_asociado"
            :state="nameState"
            type="text"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          :state="nameState"
          label="Numero de documento"
          label-for="numeroDocumentoAsociado"
          invalid-feedback="Numero de documento requerido."
        >
          <b-form-input
            id="numeroDocumentoAsociado"
            ref="numeroDocumentoAsociado"
            v-model="new_cuenta_asociada.nro_documento_asociado"
            :state="nameState"
            type="number"
            minlength=5
            maxlength=10
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          :state="nameState"
          label="Numero de socio"
          label-for="numeroSocioAsociado"
          invalid-feedback="Numero de socio requerido."
        >
          <b-form-input
            id="numeroSocioAsociado"
            ref="numeroSocioAsociado"
            v-model="new_cuenta_asociada.nro_socio_asociado"
            :state="nameState"
            type="number"
            minlength=1
            maxlength=5
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          :state="nameState"
          label="Numero de cuenta"
          label-for="altaCuentaAsociada"
          invalid-feedback="Numero de cuenta requerida."
        >
          <b-form-input
            id="altaCuentaAsociada"
            ref="altaCuentaAsociada"
            v-model="new_cuenta_asociada.nro_cuenta_asociada"
            :state="nameState"
            type="number"
            minlength=6
            maxlength=10
            required
          ></b-form-input>
        </b-form-group>
        
      </form>
    </b-modal>


  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'sipap',
  data() {
    return {
      title: 'Tranferencia SIPAP (a Bancos)',
      pin_transaccional: null,
      nameState: null,
      item : {
        tipo_transferencia: 'SIPAP-OUT',
        cuenta_origen: null,
        importe: 0,
        entidad: null,
        numero_cuenta_destino: null,
        nombre_destinatario: null,
        tipo_documento: null,
        numero_documento: null,
        motivo: null,
        localidad: null,
        concepto: null
      },
      new_cuenta_asociada: {
        nro_socio_asociado: null,
        nro_cuenta_asociada: null,
        nro_documento_asociado: null,
        nombre_cliente_asociado: null,
      },
      cuentas_origen: [
        { value: null, text: 'Seleccione una cuenta origen'}
      ],
      cuentas_destino: [
        { value: null, text: 'Seleccione una cuenta destino'},
        { value: 999, text: 'Ingresar nueva cuenta ...'}
      ],
      motivos: [],
      localidades: [],
      tiposdocumento: [],
      entidades: []
    }
  },
  methods: {

    oprimeTecla(event) {
      if (this.pin_transaccional.length > 5) return
      this.pin_transaccional = `${this.pin_transaccional}${event.target.innerHTML}`;
    },

    borrarCaracter() {
      this.pin_transaccional = this.pin_transaccional.slice(0, -1);
    },

    limpiarPIN() {
      this.pin_transaccional = null;
    },

    checkFormValidity() {
      const valid = this.$refs.formPinTransaccional.checkValidity()
      this.nameState = valid
      return valid
    },

    checkFormAltaCuentaAsociada() {
      const valid = this.$refs.formAltaCuentaAsociada.checkValidity()
      this.nameState = valid
      return valid
    },

    resetVariables() {
      this.item = {
        tipo_transferencia: 'SIPAP-OUT',
        cuenta_origen: null,
        importe: 0,
        entidad: null,
        numero_cuenta_destino: null,
        nombre_destinatario: null,
        tipo_documento: null,
        numero_documento: null,
        motivo: null,
        localidad: null,
        concepto: null
      };
      this.new_cuenta_asociada = {
        nro_socio_asociado: null,
        nro_cuenta_asociada: null,
        nro_documento_asociado: null,
        nombre_cliente_asociado: null,
      };
      this.resetModalPinTransaccional();
    },

    resetModalPinTransaccional() {
      //this.pin_transaccional = null
      this.nameState = null
    },

    handleOkPinTransaccional(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmitPinTransaccional();
    },

    handleSubmitPinTransaccional() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      // este pin transaccional tiene que llegar al backend.
      //console.log('Pin transaccional:', this.pin_transaccional)
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-pin-transaccional')
        setTimeout(async () => {
          
          const postTransferir = await this.postTransferir();
          //console.log(postTransferir);
          if (postTransferir.success) {
            this.showMessage(
              'e-Coopex',
              postTransferir.message,
              'success'
            );
          } else {
            //console.log('No success');
          }
          this.resetVariables();
          
        }, 150);
      })
    },

    resetModalAltaCuentaAsociada() {
      this.new_cuenta_asociada = {
        nro_socio_asociado: null,
        nro_cuenta_asociada: null,
        nro_documento_asociado: null,
        nombre_cliente_asociado: null,
      };
      this.nameState = null
    },

    handleOkAltaCuentaAsociada(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.handleSubmitAltaCuentaAsociada();
    },

    handleSubmitAltaCuentaAsociada() {
      // Exit when the form isn't valid
      if (!this.checkFormAltaCuentaAsociada()) {
        console.log('Not Validate Form Alta Cuenta Asociada.');
        return
      }
      // Hide the modal manually
      this.$nextTick(() => {  
        setTimeout(async () => {
          const cca = await this.postAltaCuentaAsociada();
          console.log(cca);
          if (typeof cca.fecha_hora === undefined) {
             // no hacemos nada
             //console.log('no hacemos nada');
          } else {
            this.cuentas_destino = await this.getCuentasAsociadas();
            if (!this.cuentas_destino) {
              this.cuentas_destino = [];
            }
            this.cuentas_destino.unshift( { value: null, text: `Seleccione una cuenta destino` } );
            this.cuentas_destino.push( { value: 999, text: `Ingresar nueva cuenta ...` } );
            this.$bvModal.hide('modal-alta-cuenta-asociada');
            this.showMessage(
              'e-Coopex',
              'La cuenta ha sido vinculada satisfactoriamente.',
              'success'
            );
          }
          
        }, 150);
      })
    },

    showMessage(title, message, variant = 'danger', append = true) {
      this.counter++
      this.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-bottom-full',
        solid: true,
        variant: variant,
        appendToast: append,
        autoHideDelay: 5000
      })
    },
    
    formatNumber (n) {
      if ( n >= 0 ) {
        n = String(n).replace(/\D/g, "");
      } else {
        n = '-' + String(n).replace(/\D/g, "");
      }
      return n === '' ? n : Number(n).toLocaleString();
    },

    async botonTransferir() {

      if (!this.item.cuenta_origen) {
        this.showMessage('e-Coopex', `Seleccione una cuenta de origen para transferir.`);
        this.$refs.select_co.$el.focus();
        return;
      }
      if (!this.item.entidad) {
        this.showMessage('e-Coopex', `Seleccione un banco de destino.`);
        this.$refs.select_bd.$el.focus();
        return;
      }
      if (!this.item.numero_cuenta_destino) {
        this.showMessage('e-Coopex', `Ingrese un numero de cuenta destino.`);
        this.$refs.numero_cuenta_destino.$el.focus();
        return;
      }
      if (!this.item.tipo_documento) {
        this.showMessage('e-Coopex', `Seleccione un tipo de documento del destinatario.`);
        this.$refs.select_td.$el.focus();
        return;
      }
      if (!this.item.numero_documento) {
        this.showMessage('e-Coopex', `Ingrese un numero de documento del destinatario.`);
        this.$refs.numero_documento.$el.focus();
        return;
      }
      if (!this.item.nombre_destinatario) {
        this.showMessage('e-Coopex', `Ingrese nombre completo del destinatario.`);
        this.$refs.nombre_destinatario.$el.focus();
        return;
      }
      if (!this.item.localidad) {
        this.showMessage('e-Coopex', `Seleccione una localidad.`);
        this.$refs.select_ld.$el.focus();
        return;
      }
      if (!this.item.importe) {
        this.showMessage('e-Coopex', `Ingrese el importe a transferir.`);
        this.$refs.importe.$el.focus();
        return;
      }
      if (!this.item.motivo) {
        this.showMessage('e-Coopex', `Seleccione el motivo de la transferencia.`);
        this.$refs.select_mv.$el.focus();
        return;
      }
      if (!this.item.concepto) {
        this.showMessage('e-Coopex', `Ingrese el concepto de la transferencia.`);
        this.$refs.concepto.$el.focus();
        return;
      }
      this.pin_transaccional = null;
      // El boton transferir abre el model de ingreso de PIN Transaccional.
      this.$bvModal.show('modal-pin-transaccional');
      setTimeout(() => {
        this.$refs.pinTransaccional.$el.focus();
      },150);

    },

    cambiaCuentaDestino(value) {
      // ingresamos una nueva cuenta ... 
      if (value===999) {
        this.$bvModal.show('modal-alta-cuenta-asociada');
      }
    },

    async postTransferir() {
      const loader = this.$loading.show();
      try {
        //console.log(this.item)
        const body_enviado = this.item;
        const rows = await axios.post(`${process.env.VUE_APP_API_URL}/sipap/transferir`, body_enviado, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`,
            ControlKey: this.pin_transaccional+''
          }
        })
        return rows.data;
      } catch (err) {
        let message = err.message;
        if (err.response && err.response.data ) {
          message = err.response.data.message;
        } 
        //this.resetVariables();
        this.showMessage('e-Coopex', message);
        return [];
      } finally {
        loader.hide();
      }
    },

    async postAltaCuentaAsociada() {
      const loader = this.$loading.show();
      try {
        const body_enviado = this.new_cuenta_asociada;
        const rows = await axios.post(`${process.env.VUE_APP_API_URL}/transferencias/cca`, body_enviado, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
        return rows.data;
      } catch (err) {
        let message = err.message;
        if (err.response && err.response.data ) {
          message = err.response.data.message;
        } 
        //this.resetVariables();
        this.showMessage('e-Coopex', message);
        return [];
      } finally {
        loader.hide();
      }
    },

    async getCuentas() {
      const loader = this.$loading.show();
      try {
         const socio = await axios.post(`${process.env.VUE_APP_API_URL}/consulta/socio`, {
          socio_numero: +window.localStorage.getItem("nro_socio")
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
        return socio.data.cuentas
          .filter((cuenta) => cuenta.codigo_cuenta == "AH")
          .map((cuenta, i) => { return { value: cuenta.nro_cuenta, text: `${cuenta.nro_cuenta} | Saldo: ${ this.formatNumber(cuenta.saldo_cuenta) } Gs.` } });
      } catch (error) {
         console.log(`Error al buscar cuentas del socio. Mensaje: ${error.message}`);
      } finally {
        loader.hide();
      } 
    },

    async getCuentasAsociadas() {
      const loader = this.$loading.show();
      try {
         const rows = await axios.get(`${process.env.VUE_APP_API_URL}/transferencias/cuentas_asociadas`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
        //console.log(rows.data);
        return rows.data
          .map((cuenta, i) => { return { value: {nro_socio_asociado: cuenta.nro_socio_asociado, nro_cuenta_asociada: cuenta.nro_cuenta_asociada}, text: `${cuenta.nro_cuenta_asociada} | ${ cuenta.apellido ? cuenta.apellido + ', ' +cuenta.nombre : cuenta.nombre_cliente_asociado }` } });
      } catch (error) {
         console.log(`Error al buscar cuentas asociadas. Mensaje: ${error.message}`);
      } finally {
        loader.hide();
      } 
    },

    async getMotivos() {
      const loader = this.$loading.show();
      try {
         const rows = await axios.get(`${process.env.VUE_APP_API_URL}/sipap/motivos`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
        //console.log(rows.data);
        return rows.data
          .map((motivo, i) => { return { value: {id: motivo.id, code: motivo.code}, text: `${motivo.description}` } });
      } catch (error) {
         console.log(`Error al buscar lista de motivos. Mensaje: ${error.message}`);
      } finally {
        loader.hide();
      } 
    },

    async getLocalidades() {
      const loader = this.$loading.show();
      try {
         const rows = await axios.get(`${process.env.VUE_APP_API_URL}/sipap/localidades`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
        //console.log(rows.data);
        return rows.data
          .map((localidad, i) => { return { value: {id: localidad.id, code: localidad.code}, text: `${localidad.description}` } });
      } catch (error) {
         console.log(`Error al buscar lista de localidades. Mensaje: ${error.message}`);
      } finally {
        loader.hide();
      } 
    },

    async getDocumentos() {
      const loader = this.$loading.show();
      try {
         const rows = await axios.get(`${process.env.VUE_APP_API_URL}/sipap/documentos`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
        //console.log(rows.data);
        return rows.data
          .map((documento, i) => { return { value: {id: documento.id, code: documento.code}, text: `${documento.description}` } });
      } catch (error) {
         console.log(`Error al buscar lista de documentos. Mensaje: ${error.message}`);
      } finally {
        loader.hide();
      } 
    },

    async getEntidades() {
      const loader = this.$loading.show();
      try {
         const rows = await axios.get(`${process.env.VUE_APP_API_URL}/sipap/entidades`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
        console.log(rows.data);
        return rows.data
          .map((entidad, i) => { return { value: {id: entidad.id, affiliateid: entidad.affiliateid}, text: `${entidad.name}` } });
      } catch (error) {
         console.log(`Error al buscar lista de entidades bancarias. Mensaje: ${error.message}`);
      } finally {
        loader.hide();
      } 
    },

  },
  async mounted() {
    
    this.cuentas_origen = await this.getCuentas();
    if (!this.cuentas_origen) {
      this.cuentas_origen = [];
    }
    this.cuentas_origen.unshift( { value: null, text: `Seleccione una cuenta` } );

    this.entidades = await this.getEntidades();
    this.entidades.unshift( { value: null, text: `Seleccione un banco destino` } );
    
    this.motivos = await this.getMotivos();
    this.motivos.unshift( { value: null, text: `Seleccione un motivo` } );

    this.localidades = await this.getLocalidades();
    this.localidades.unshift( { value: null, text: `Seleccione una localidad` } );

    this.tiposdocumento = await this.getDocumentos();
    this.tiposdocumento.unshift( { value: null, text: `Seleccione un documento` } );
    

    // this.cuentas_destino = await this.getCuentasAsociadas();
    // if (!this.cuentas_destino) {
    //   this.cuentas_destino = [];
    // }
    // this.cuentas_destino.unshift( { value: null, text: `Seleccione una cuenta destino` } );
    // this.cuentas_destino.push( { value: 999, text: `Ingresar nueva cuenta ...` } );
  }
};

</script> 

<style>
.formulario {
  margin: 2em;
  text-align: left;
  padding-top: 20px;
}
.boton_teclado {
  box-shadow:inset 0px 1px 0px 0px #ffffff;
	background:linear-gradient(to bottom, #ffffff 5%, #f6f6f6 100%);
	background-color:#ffffff;
	border-radius:5px;
	border:1px solid #dcdcdc;
	display:inline-block;
	cursor:pointer;
	color:#666666;
  align-items: center;
  text-align: center;
  padding: 5px;
  width: 50px;
  font-size: 18px;
  font-weight: bold;
  text-decoration:none;
	text-shadow:0px 1px 0px #ffffff;
}
.boton_teclado:hover {
  background:linear-gradient(to bottom, #f6f6f6 5%, #ffffff 100%);
	background-color:#f6f6f6;
}
.input_clave {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  width: 216px;
  margin-left: 120px;
  line-height: 30px;
  height: 32px;
  padding-top: 1px;
}
.fila_numeros {
  width:250px; 
  border: 0px solid black;
  margin-top: 5px;
  margin-left:105px;
}
.label-pin {
  margin-left: 125px !important;
}
</style>